var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-4 mt-3" }, [
      _c("div", [_c("strong", [_vm._v(_vm._s(_vm.name))])])
    ]),
    _c("div", { staticClass: "col-8 mt-3" }, [
      _c("div", [_vm._t("content")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }